module.exports = __webpack_public_path__ + "img/vanoort.3d721956.svg";